module.exports = __webpack_public_path__ + "img/18.b9e1cae0.png";